import { useForm, Controller } from 'react-hook-form'
import { useLocation, useNavigate, useOutletContext } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { nextPage } from 'components/RCPro/helpers/nav'
import api from 'helpers/api'
import classNames from 'classnames'
import MaskedInput from 'react-text-mask'
import Input from 'components/common/Input/Input'
import InputError from 'components/common/InputError/InputError'
import Arrow from 'components/assets/icons/Arrow'
import Button from 'components/common/Button/Button'
import { expirationDateValidationFx, numberValidationCardNumberFx, numberValidationCVCFx, formParams } from 'constants/inputValidation'

const CardForm = ({ state }) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const [ nextPageTransition ] = useOutletContext()
  const { CB, layout: { next } } = state.texts

  // Initialize form
  const required = t('mainReporting:form.mandatory')
  const {
    register,
    formState: { errors, isValid },
    handleSubmit,
    control
  } = useForm({
    ...formParams,
    values:{
      owner: '',
      number: '',
      expirationDate: '',
      ccv: ''
    }
  })

  // Submit form
  const onSubmit = handleSubmit(async data => {
    try{
      // const res = await api.post({
      //   url: '/adhesions/client',
      //   data: {},
      //   headers: { Authorization: `Bearer ${state.token}` },
      // })

      nextPage({ pathname, state, navigate })
      nextPageTransition()
    } catch (err) {
      console.log('Payment error')
    }
  })


  return (
    <>
      <h1>{CB.title}</h1>

      <form onSubmit={onSubmit}>

        <Input
          error={errors.owner}
          register={register('owner', { required })}
          label={t('mainReporting:form.CB.name.label')}
          placeholder={t('mainReporting:form.CB.name.placeholder')}
          disallowNumbers={true}
        />
        <InputError error={errors.owner} />


        <div className="input-label">{t('mainReporting:form.CB.number.label')}</div>
        <Controller
          control={control}
          name="number"
          rules={numberValidationCardNumberFx(t)}
          render={({ field: { onBlur, onChange, value } }) => (
            <MaskedInput
              className={classNames('masked-input', errors.number && 'error')}
              mask={[/\d/, /\d/, /\d/, /\d/,
                ' ', /\d/, /\d/, /\d/, /\d/,
                ' ', /\d/, /\d/, /\d/, /\d/,
                ' ', /\d/, /\d/, /\d/, /\d/,
              ]}
              guide={false}
              keepCharPositions={false}
              onBlur={onBlur}
              onChange={value => onChange(value)}
              placeholder={t('mainReporting:form.CB.number.placeholder')}
              value={value}
              disallowletters={value}
            />
          )}
        />
        <InputError error={errors.number} />


        <div className="input-label">{t('mainReporting:form.CB.expiration.label')}</div>
        <Controller
          control={control}
          name="expirationDate"
          rules={expirationDateValidationFx(t)}
          render={({ field: { onBlur, onChange, value } }) => (
            <MaskedInput
              className={classNames('masked-input', errors.expirationDate && 'error')}
              mask={[/\d/, /\d/, '/', /\d/, /\d/]}
              guide={false}
              keepCharPositions={false}
              onBlur={onBlur}
              onChange={value => onChange(value)}
              placeholder={t('mainReporting:form.CB.expiration.label')}
              value={value}
              disallowletters={value}
            />
          )}
        />
        <InputError error={errors.expirationDate} />


        <Input
          maxLength="4"
          error={errors.ccv}
          register={register('ccv', numberValidationCVCFx(t))}
          label={t('mainReporting:form.CB.ccv.placeholder')}
          placeholder={t('mainReporting:form.CB.ccv.placeholder')}
          disallowLetters={true}
        />
        <InputError error={errors.ccv} />


        <Button
          label={<>{next} <Arrow /></>}
          onClick={handleSubmit}
          type="primary"
          disabled={!isValid}
        />
      </form>
    </>
  )
}

export default CardForm
